export class SearchDataType {

    constructor(
        public id: number,
        public name: string
    ){}
}
